import { SettingName } from '../../Types';
import { actionTypes } from './actions';

export const PlayerUIReducer = (state, action) => {
    let isThisModalOpen: boolean;
    switch (action.type) {
        case actionTypes.SEEKING_STARTED:
            return {
                ...state,
                isOnLiveEdge: null,
                isSeeking: true,
            };
        case actionTypes.SEEKING_ENDED:
            return {
                ...state,
                isSeeking: false,
            };
        case actionTypes.DRAG_SEEKING_STARTED:
            return {
                ...state,
                isOnLiveEdge: null,
                isSeeking: true,
                isDragSeeking: true,
            };
        case actionTypes.DRAG_SEEKING_ENDED:
            return {
                ...state,
                isSeeking: false,
                isDragSeeking: false,
            };
        case actionTypes.OPEN_MODAL:
            return {
                ...state,
                isAnyModalOpen: true,
                [action.modal]: {
                    ...state[action.modal],
                    isOpen: true,
                },
            };
        case actionTypes.CLOSE_MODAL:
            return {
                ...state,
                isAnyModalOpen: false, // TODO: Check if true once we have more then 1 modal
                [action.modal]: {
                    ...state[action.modal],
                    isOpen: false,
                },
            };
        case actionTypes.TOGGLE_MODAL:
            isThisModalOpen = state[action.modal].isOpen;
            return {
                ...state,
                // TODO: Check if true once we have more then 1 modal
                isAnyModalOpen: !isThisModalOpen,
                [action.modal]: {
                    ...state[action.modal],
                    isOpen: !isThisModalOpen,
                    setting: action.setting ?? SettingName.AudioSubtitles,
                },
            };
        case actionTypes.RELATIVE_SEEK:
            return {
                ...state,
                relativeSeekValue: state.relativeSeekValue + action.relativeSeekAmount,
                seekAction: 'relative',
            };
        case actionTypes.RELATIVE_SEEK_COMPLETED:
            return {
                ...state,
                relativeSeekValue: null,
            };
        case actionTypes.ABSOLUTE_SEEK:
            return {
                ...state,
                seekAction: 'absolute',
                dvrPoint: action.dvrPoint,
            };
        case actionTypes.VOLUME_OPEN:
            return {
                ...state,
                isVolumeOpened: true,
            };
        case actionTypes.VOLUME_CLOSE:
            return {
                ...state,
                isVolumeOpened: false,
            };
        case actionTypes.SHOW_UI:
            return {
                ...state,
                uiDisplayed: true,
                uiHidden: false,
            };
        case actionTypes.HIDE_UI:
            return {
                ...state,
                uiDisplayed: false,
            };
        case actionTypes.HIDE_UI_COMPLETED:
            return {
                ...state,
                uiHidden: true,
            };
        case actionTypes.TV_SEEKING_ENABLED:
            return {
                ...state,
                TVseekingEnabled: true,
            };
        case actionTypes.TV_SEEKING_DISABLED:
            return {
                ...state,
                TVseekingEnabled: false,
            };
        case actionTypes.BINGE_WATCHING_OVERLAY_SHOW:
            return {
                ...state,
                bingeWatchingOverlay: {
                    isOpen: true,
                    isDismissed: false,
                    remainingTime: action.remainingTime,
                },
            };
        case actionTypes.BINGE_WATCHING_OVERLAY_HIDE:
            return {
                ...state,
                bingeWatchingOverlay: {
                    isOpen: false,
                    isDismissed: action.isFromUserAction,
                    remainingTime: -1,
                },
            };
        case actionTypes.BINGE_WATCHING_OVERLAY_SET_REMAINING_TIME:
            return {
                ...state,
                bingeWatchingOverlay: {
                    ...state.bingeWatchingOverlay,
                    remainingTime: action.remainingTime,
                },
            };
        case actionTypes.SET_IS_ON_LIVE_EDGE:
            return {
                ...state,
                isOnLiveEdge: action.isOnLiveEdge,
            };
        default:
            return state;
    }
};
